export type PulseSubscriptionStatus = 'pending' | 'active' | 'expired';

export function getPulseSubscriptionStatus(
    startedAt: string | null,
    expiresAt: string | null,
    now = new Date(),
): PulseSubscriptionStatus {
    const currentTime = now.getTime();
    if (startedAt && currentTime < new Date(startedAt).getTime()) {
        return 'pending';
    }
    if (expiresAt && currentTime > new Date(expiresAt).getTime()) {
        return 'expired';
    }
    return 'active';
}
